import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Linkedin, Facebook } from "lucide-react";
import PaymentMarks from "./PaymentMarks";

export const Footer = () => {
    return (
        <footer className="bg-brand-jet border-t border-brand-gold/15 pt-20 pb-10" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="font-cursive text-4xl sm:text-5xl text-brand-gold leading-none">
                            Real Estate
                        </div>
                        <div className="mt-1 text-[0.65rem] tracking-[0.45em] text-brand-silver/70 uppercase">
                            &amp; Administration Inc · Las Vegas
                        </div>
                        <p className="mt-8 text-sm text-brand-silver/70 leading-relaxed max-w-md">
                            Commercial and ultra-luxury residential representation for private clients,
                            family offices, and institutional capital. Discreet. Surgical. Uncompromising.
                        </p>
                        <div className="flex items-center gap-4 mt-8">
                            <a href="#" aria-label="Instagram" className="text-brand-silver/60 hover:text-brand-gold transition" data-testid="footer-social-ig"><Instagram size={18} /></a>
                            <a href="#" aria-label="LinkedIn" className="text-brand-silver/60 hover:text-brand-gold transition" data-testid="footer-social-li"><Linkedin size={18} /></a>
                            <a href="#" aria-label="Facebook" className="text-brand-silver/60 hover:text-brand-gold transition" data-testid="footer-social-fb"><Facebook size={18} /></a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[0.7rem] tracking-[0.4em] uppercase text-brand-gold mb-6">Navigate</div>
                        <ul className="space-y-3 text-sm">
                            <li><Link to="/about" className="text-brand-silver/80 hover:text-brand-gold transition" data-testid="footer-link-about">About</Link></li>
                            <li><Link to="/commercial" className="text-brand-silver/80 hover:text-brand-gold transition" data-testid="footer-link-commercial">Commercial</Link></li>
                            <li><Link to="/residential" className="text-brand-silver/80 hover:text-brand-gold transition" data-testid="footer-link-residential">Luxury Residential</Link></li>
                            <li><Link to="/services" className="text-brand-silver/80 hover:text-brand-gold transition" data-testid="footer-link-services">Services</Link></li>
                            <li><Link to="/agents" className="text-brand-silver/80 hover:text-brand-gold transition" data-testid="footer-link-agents">Agents</Link></li>
                            <li><Link to="/events" className="text-brand-silver/80 hover:text-brand-gold transition" data-testid="footer-link-events">Events</Link></li>
                            <li><Link to="/contact" className="text-brand-silver/80 hover:text-brand-gold transition" data-testid="footer-link-contact">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-[0.7rem] tracking-[0.4em] uppercase text-brand-gold mb-6">Headquarters</div>
                        <ul className="space-y-4 text-sm text-brand-silver/80">
                            <li className="flex gap-3"><MapPin size={16} className="text-brand-gold shrink-0 mt-0.5" /><span>2685 S Rainbow Blvd, Suite 212<br />Las Vegas, NV 89146</span></li>
                            <li className="flex gap-3"><Phone size={16} className="text-brand-gold shrink-0 mt-0.5" /><a href="tel:+18336494628" className="hover:text-brand-gold transition" data-testid="footer-phone">833.649.4628</a></li>
                            <li className="flex gap-3"><Mail size={16} className="text-brand-gold shrink-0 mt-0.5" /><a href="mailto:info@adminrealestatehq.online" className="hover:text-brand-gold transition" data-testid="footer-email">info@adminrealestatehq.online</a></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-10 border-t border-white/5">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                        <div>
                            <div className="text-[0.7rem] tracking-[0.4em] uppercase text-brand-gold mb-4">Payments Accepted</div>
                            <PaymentMarks />
                            <p className="mt-3 text-[0.62rem] tracking-[0.2em] uppercase text-brand-silver/40">
                                Earnest deposits, retainers & closing funds also accepted via escrow wire & certified cashier's check.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-10 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-brand-silver/50 tracking-wider">
                        © {new Date().getFullYear()} Real Estate &amp; Administration Inc. All rights reserved.
                    </p>
                    <p className="text-[0.65rem] tracking-[0.35em] uppercase text-brand-silver/40">
                        Licensed Nevada Brokerage · Equal Housing Opportunity
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
